/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { useEffect, useReducer } from "react";
import formReducer from "../../shared/forms/formReducer";
import useApitarifaPermisionarios from "../../api/operaciones/useApiTarifasPermisionarios";
import FormHandler from "../../shared/forms/formHandler";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import FieldInputNumber from "../../shared/controls/fieldInputNumber";
import TarifaPermisionariosValidacionEsquema from "./tarifaPermisionariosValidacionEsquema";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";

const TarifaPermisionarioDetalle = ({ tarifaPermisionarioId, onSave, soloLectura }) => {
    const api = useApitarifaPermisionarios();
    const defaultEntity = () => ({ entity: { id: 0 } });

    const [{ entity, errors }, dispatch] = useReducer(
        formReducer, {}, defaultEntity
    );

    const formHandler = new FormHandler({
        validationSchema: TarifaPermisionariosValidacionEsquema,
        api,
        dispatch
    });

    useEffect(() => {
        async function cargar() {
            const tarifas = await api.obtener(tarifaPermisionarioId);
            dispatch({ type: "update", value: tarifas });
            console.log(tarifas)
        }

        if (tarifaPermisionarioId > 0) {
            cargar().then();
        }
    }, []);

 
   const guardar = async () => {
    const payload = {
        id: entity.id ?? 0,
        permisionarioId:  entity.permisionario?.id,
        tipoUnidad: entity.tipoUnidad?.id,
        tipoViaje: entity.tipoViaje?.id,
        estadoOrigenid: entity.estadoOrigenId?.id,   
        municipioOrigenId: entity.municipioOrigenId?.id,
        estadoDestinoId: entity.estadoDestinoId? entity.estadoDestinoId?.id :0,
        municipioDestinoid: entity.municipioDestinoId? entity.municipioDestinoId?.id:0,
        tarifa: entity.tarifa ?? 0,
        moneda: entity.moneda?.id
    };
  await formHandler.save(payload);
    //if (formHandler.validation?.result) {
        onSave();
   // }
    };


    const actualizar = (value, propertyName) => {
        dispatch({
            type: 'update',
            value: value,
            name: propertyName
        });
    };

    return (
        <>
            <div className="form-container full-height">                
                <ReadOnlyProvider defaultReadOnly={soloLectura}>
                    <div className="form-row">
                        <FieldDropDown
                        name="permisionario"
                        label="Permisionario"
                        source="permisionarios"
                        filter
                        required
                        colMd={6}
                        valueAsId={true}
                        value={
                                entity.permisionario ??              
                                entity.permisionario?.id ??           
                                null
                        }
                        onChange={actualizar}
                        errors={errors}
                        />

                        <FieldDropDown name="tipoUnidad" label="Tipo unidad"  source="tiposUnidad"  filter required colMd={6}  
                        valueAsId={true}
                        value={
                                entity.tipoUnidad ??              
                                entity.tipoUnidad?.id ??           
                                null
                        }
                        onChange={actualizar} errors={errors} />
                        <FieldDropDown name="tipoViaje" label="Tipo viaje"  source="tiposviajePermisionarios"  filter required colMd={6} 
                        valueAsId={true}
                               value={
                                entity.tipoViaje ??              
                                entity.tipoViaje?.id ??           
                                null
                        }
                        onChange={actualizar} errors={errors} />
                          <FieldDropDown
                                name="estadoOrigenId"
                                source="estados"
                                label="Estado Origen"
                                colMd={6}
                                filter={true}
                                required={true}
                                 valueAsId={true}
                                  value={                                        
                                entity.estadoOrigenId?.id }
                                onChange={actualizar}
                            />

                         <FieldDropDown
                            name="municipioOrigenId"
                            source={
                                entity.estadoOrigenId
                                ? `municipiosEstados/${entity.estadoOrigenId.nombre}`
                                : "municipiosEstados/0"
                            }
                            label="Municipio Origen"
                            params={{ estadoId: entity.estadoOrigenId?.nombre }}
                            colMd={6}
                            filter={true}
                            required={true}
                             valueAsId={true}
                            value={         
                                entity.municipioOrigenId?.id 
                            }                 
                            onChange={actualizar}
                            disabled={!entity.estadoOrigenId}
                        />
                        <FieldDropDown
                            name="estadoDestinoId"
                            source="estados"
                            label="Estado Destino"
                            colMd={6}
                            filter={true}
                            required={true}
                            valueAsId={true}
                           value={
                                entity.estadoDestinoId?.id 
                            }    
                            onChange={actualizar}
                        />

                        <FieldDropDown
                            name="municipioDestinoId"
                            source={
                                entity.estadoDestinoId
                                ? `municipiosEstados/${entity.estadoDestinoId.nombre}`
                                : "municipiosEstados/0"
                            }
                            label="Municipio Destino"
                            params={{ estadoId: entity.estadoDestinoId?.nombre }}
                            colMd={6}
                            filter={true}
                            required={true}
                            valueAsId={true}
                             value={ 
                                entity.municipioDestinoId?.id
                            }  
                            onChange={actualizar}
                            disabled={!entity.estadoDestinoId}
                        />

                         <FieldInputNumber label={'Tarifa'} name={'tarifa'} colMd={6} 
                                      value={entity?.tarifa} onChange={actualizar} fractionDigits={2}/>
                        <FieldDropDown name="moneda" label="Moneda" source="moneda"  filter required colMd={6} valueAsId={true}
                            value={
                                entity.monedaId ??              
                                entity.moneda?.id ??           
                                null
                            }
                        onChange={actualizar} errors={errors} />
                    </div>
                    
                </ReadOnlyProvider>
                <div className="form-footer">
                    {!soloLectura &&
                        <Button label="Guardar" type="button" onClick={guardar} />
                    }
                </div>
            </div>
        </>
    );
};

export default TarifaPermisionarioDetalle;